// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CashKeypadController from "./cash_keypad_controller"
application.register("cash-keypad", CashKeypadController)

import CashNumpadController from "./cash_numpad_controller"
application.register("cash-numpad", CashNumpadController)

import CashPaymentCancelController from "./cash_payment_cancel_controller"
application.register("cash-payment-cancel", CashPaymentCancelController)

import CashReceiptController from "./cash_receipt_controller"
application.register("cash-receipt", CashReceiptController)

import CategoryController from "./category_controller"
application.register("category", CategoryController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import DefaultsController from "./defaults_controller"
application.register("defaults", DefaultsController)

import DrawersController from "./drawers_controller"
application.register("drawers", DrawersController)

import ForceFocusController from "./force_focus_controller"
application.register("force-focus", ForceFocusController)

import ItemController from "./item_controller"
application.register("item", ItemController)

import KioskController from "./kiosk_controller"
application.register("kiosk", KioskController)

import KioskReceiptController from "./kiosk_receipt_controller"
application.register("kiosk-receipt", KioskReceiptController)

// KIOSK_STANDBY_DISABLED
// import KioskStandbyController from "./kiosk_standby_controller"
// application.register("kiosk-standby", KioskStandbyController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import ItemEditorController from "./item_editor_controller"
application.register("item-editor", ItemEditorController)

import ItemImageUploaderController from "./item_image_uploader_controller"
application.register("item-image-uploader", ItemImageUploaderController)

import KioskItemInfoController from "./kiosk_item_info_controller"
application.register("kiosk-item-info", KioskItemInfoController)

import KioskOptionSelectController from "./kiosk_option_select_controller"
application.register("kiosk-option-select", KioskOptionSelectController)

import PosOptionSelectController from "./pos_option_select_controller"
application.register("pos-option-select", PosOptionSelectController)

import OptionGroupFormController from "./option_group_form_controller"
application.register("option-group-form", OptionGroupFormController)

import OptionGroupsManagerController from "./option_groups_manager_controller"
application.register("option-groups-manager", OptionGroupsManagerController)

import PosController from "./pos_controller"
application.register("pos", PosController)

import ModalsCloseController from "./modals_close_controller"
application.register("modals-close", ModalsCloseController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import PosCategoryEditorController from "./pos_category_editor_controller"
application.register("pos-category-editor", PosCategoryEditorController)

import PosCountNumpadController from "./pos_count_numpad_controller"
application.register("pos-count-numpad", PosCountNumpadController)

import PrinterController from "./printer_controller"
application.register("printer", PrinterController)

import ReceiptDetailViewerController from "./receipt_detail_viewer_controller"
application.register("receipt-detail-viewer", ReceiptDetailViewerController)

import ReceiptPrinterController from "./receipt_printer_controller"
application.register("receipt-printer", ReceiptPrinterController)

import RepotController from "./repot_controller"
application.register("repot", RepotController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import VoucherInputNumpadController from "./voucher_input_numpad_controller"
application.register("voucher-input-numpad", VoucherInputNumpadController)

import VoucherNumpadController from "./voucher_numpad_controller"
application.register("voucher-numpad", VoucherNumpadController)
